import React from "react";
import { Button } from "antd";
import subscriptions from "@services/subscriptions";
import { alertPopup } from '@utils/popup'

class UpdateCollectiveStatus extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showActivate: false,
            showDeactivate: false
        }
    }

    updateStatus = (status) => {
        const { agentInfo: { id: agentId } } = this.props
    
        subscriptions.updateSubscriptionStatus({ agentId, status })
        .then(() => { 
                        alertPopup({ type: 'success', title: 'העדכון בוצע בהצלחה' })
                        this.props.updateInfo()
                    })
        .catch(() => { alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' }) })

        this.setState({ showActivate: false,  showDeactivate: false })
    }
    
    render() {
        
        const { showActivate, showDeactivate } = this.state
        return (
            <div style={{ ...style.wrapper }}>
                <div style={{ ...style.buttonContainer }}>
                    {(!showActivate && !showDeactivate) &&
                        <>
                            <button style={{ ...style.button, ...style.rightButton }} onClick={() => this.setState({ showDeactivate: true })}>{"חסימת מינויים"}</button>
                            <button style={{ ...style.button, ...style.leftButton }} onClick={() => this.setState({ showActivate: true })}>{"הפעלת מינויים"}</button>
                        </>}

                    {showActivate && 
                        <div>
                            <span>{"האם להפעיל מינויים?"}</span>
                            <div style={{ ...style.box }}>
                                <Button onClick={() => this.updateStatus('ACTIVE')}>{"כן"}</Button>
                                <Button onClick={() => this.setState({ showActivate: false })}>{"לא"}</Button>
                            </div>
                        </div>}

                    {showDeactivate && 
                    <div>
                        <span>{"האם לחסום מינויים?"}</span>
                        <div style={{ ...style.box }}>
                            <Button onClick={() => this.updateStatus('AWAITING_BANK_TRANSFER')}>{"כן"}</Button>
                            <Button onClick={() => this.setState({ showDeactivate: false })}>{"לא"}</Button>
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    wrapper: { display: 'flex', justifyContent: 'end' },
    buttonContainer: { display: 'flex', height: '60px' },
    rightButton: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftButton: { cursor: 'pointer', borderRadius: '4px 0 0 4px' },
    button: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    box: {  }
}

export default UpdateCollectiveStatus